module.exports = {"371073107":"草庙子镇","371073112":"汪疃镇","371073113":"苘山镇","371073400":"黄岚"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371073.json
// module id = 1447
// module chunks = 0